/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/call-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 260,
    },
    columnWidth: {
        callId: 70,
        callDateAndTime: 80,
        duration: 70,
        callCallerType: 80,
        caller: 100,
        members: 150,
        representative: 150,
        resolution: 80,
        categoryAndReason: 140,
        
        // special columns
        _groupActions: 80, // group actions column
    },
    columnIcons: {
        callId: {
            name: 'transferCall',
            path: 'additionalValues.callTransferred', // inside individual `item` data
        }
    },
    filterFlyoutWidths: {
        callCallerType: 200,
        resolution: 180,
        categoryAndReason: 300,
    },
    valueColors: {
        resolution: {
            resolved: '#59ad00',
            unresolved: '#e7aa00',
        },
    },
    actionIcons: {
        markResolved: 'checkedCircle',
        callRecording: 'mic'
    },
};
